import { Editor } from 'roosterjs-editor-core';
import { ChangeSource, PluginEvent, PluginEventType } from 'roosterjs-editor-types';

export default function linkPreviewPluginTrigger(evt: PluginEvent, editor: Editor) {
    return (
        isPossibleLinkPreviewEvent(evt) &&
        editor
            .getContent(false /*triggerExtractContentEvent*/)
            .toLowerCase()
            .indexOf('<a ') >= 0
    );
}

function isPossibleLinkPreviewEvent(event: PluginEvent) {
    return (
        (event.eventType === PluginEventType.ContentChanged &&
            (event.source === ChangeSource.AutoLink || ChangeSource.SetContent)) ||
        event.eventType === PluginEventType.EditorReady
    );
}
